import { baseSyntheticEvent } from './base';

/**
 * Experimental values:
 * - iOS: `{"changedTouches": [[Circular]], "identifier": 1, "locationX": 253, "locationY": 30.333328247070312, "pageX": 273, "pageY": 141.3333282470703, "target": 75, "timestamp": 875928682.0450834, "touches": [[Circular]]}`
 * - Android: `{"changedTouches": [[Circular]], "identifier": 0, "locationX": 160, "locationY": 40.3636360168457, "pageX": 180, "pageY": 140.36363220214844, "target": 53, "targetSurface": -1, "timestamp": 10290805, "touches": [[Circular]]}`
 */
export function buildTouchEvent() {
  return {
    ...baseSyntheticEvent(),
    nativeEvent: {
      changedTouches: [] as unknown[],
      identifier: 0,
      locationX: 0,
      locationY: 0,
      pageX: 0,
      pageY: 0,
      target: 0,
      timestamp: Date.now(),
      touches: [] as unknown[],
    },
    currentTarget: { measure: () => {} },
  };
}

export type TouchEvent = ReturnType<typeof buildTouchEvent>;

export function buildResponderGrantEvent() {
  return {
    ...buildTouchEvent(),
    dispatchConfig: { registrationName: 'onResponderGrant' },
  };
}

export function buildResponderReleaseEvent() {
  return {
    ...buildTouchEvent(),
    dispatchConfig: { registrationName: 'onResponderRelease' },
  };
}

/**
 * Experimental values:
 * - iOS: `{"eventCount": 0, "target": 75, "text": ""}`
 * - Android: `{"target": 53}`
 */
export function buildFocusEvent() {
  return {
    ...baseSyntheticEvent(),
    nativeEvent: {
      target: 0,
    },
  };
}

/**
 * Experimental values:
 * - iOS: `{"eventCount": 0, "target": 75, "text": ""}`
 * - Android: `{"target": 53}`
 */
export function buildBlurEvent() {
  return {
    ...baseSyntheticEvent(),
    nativeEvent: {
      target: 0,
    },
  };
}
